import { render, staticRenderFns } from "./AuthConfirmMail.vue?vue&type=template&id=bb67ce8e&scoped=true"
import script from "./AuthConfirmMail.vue?vue&type=script&lang=js"
export * from "./AuthConfirmMail.vue?vue&type=script&lang=js"
import style0 from "./AuthConfirmMail.vue?vue&type=style&index=0&id=bb67ce8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb67ce8e",
  null
  
)

export default component.exports